module.exports = __webpack_public_path__ + "static/media/QR.01715715.png";